import runtimeEnv from "@mars/heroku-js-runtime-env";

const config = {
  ...process.env,
  ...runtimeEnv()
};

export default config;
